<template>
 <v-card>
    <v-card-title>
        Настройка Быстрый меню
    </v-card-title>
    <v-card-text>
        <template>
            <v-data-table
              :headers="headers"
              :items="menus"
              :items-per-page="7"
              :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
              class="elevation-1"
            >

            <template v-slot:item.actions="{ item }">
                <v-icon small  class="mr-2"  @click="edit_menu(item)">mdi-pencil</v-icon>
            </template>


        </v-data-table>
          </template>

    </v-card-text>

    <v-dialog
      v-model="edit_menu_dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5">
            Редактирование меню
        </v-card-title>

        <v-card-text>
            <v-text-field
            v-model="nom_menu"
            label="Наименование"
            ></v-text-field>
            <v-divider></v-divider>

                <v-combobox
                v-model="selected"
                item-text="nom"
                item-value="id_mol"
                :items="molho"
                label="Выберите товары"
                multiple
                outlined
                chips
                small-chips
                clear-icon="mdi-close-circle"
                deletable-chips
            ></v-combobox>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="edit_menu_dialog = false"
          >
            Отмена
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="save_menu"
            :loading="loading"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-snackbar
    v-model="snack"
    :timeout="3000"
    :color="snackColor"
  >
    {{ snackText }}

    <template v-slot:action="{ attrs }">
      <v-btn
        v-bind="attrs"
        text
        @click="snack = false"
      >
        Закрыть
      </v-btn>
    </template>
  </v-snackbar>

 </v-card>
</template>

<script>
import { thisTypeAnnotation } from '@babel/types';

  export default {
    data () {
      return {

        snack: false,
            snackColor: '',
            snackText: '',
            loading: false,
        headers: [
          {
            text: '№',
            align: 'start',
            sortable: false,
            value: 'id_menu_name',
          },
          { text: 'Наименование', value: 'nom' },
          { text: 'Действия', value: 'actions', sortable: false },
        ],
        menus:[],
        nom_menu: '',
        id_menu_name: '',
        edit_menu_dialog: false,
        molho: [],
        selected: [],

      }
    },
    mounted(){
        this.get_menus()
    },
    methods:{
        get_menus(){

            this.loading = true;
        axios.get('/api/get_nom_menus',
                    {
                        headers: {
                            "Content-type": "application/json"
                        }
                    })
                    .then(response => {
                            if(response.data.status){
                                this.loading = false;
                                this.menus = response.data.menus;
                                this.molho = response.data.molho;

                            }else{
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = "Ошибка получения меню"


                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                            }
                        })
                        .catch(error => {
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = error.response.data.message;
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                        });

        },

        edit_menu(item){
            this.nom_menu = item.nom;
            this.id_menu_name = item.id_menu_name;
            this.edit_menu_dialog = true;
            this.get_menus_mol(item.id_menu_name);
        },

        get_menus_mol(id_menu){

            axios.get('/api/get_menus_mol/'+ id_menu,
                    {
                        headers: {
                            "Content-type": "application/json"
                        }
                    })
                    .then(response => {
                            if(response.data.status){
                                this.loading = false;
                                this.selected = [];
                                this.selected = response.data.selected;


                            }else{
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = "Ошибка получения меню"


                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                            }
                        })
                        .catch(error => {
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = error.response.data.message;
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                        });

        },

        save_menu(){
            this.loading = true;
            var form = {
                id_menu_name: this.id_menu_name,
                nom_menu: this.nom_menu,
                selected: this.selected
            }
            if(this.nom_menu == ''){
                this.snack = true
                this.snackColor = 'error'
                this.snackText = "Введите наименование меню"
                setTimeout(() => {
                    this.snack = false;
                }, 2000);
            }else{

            axios.post('/api/save_menu', form,
                    {
                        headers: {
                            "Content-type": "application/json"
                        }
                    })
                    .then(response => {
                            if(response.data.status){
                                this.loading = false;
                                this.edit_menu_dialog = false;
                                this.snack = true
                                this.snackColor = 'success'
                                this.snackText = "Меню сохранено"
                                this.get_menus();

                            }else{
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = "Ошибка получения меню"


                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                            }
                        })
                        .catch(error => {
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = error.response.data.message;
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                        });

                    }


        }

    }
  }
</script>

<style>

</style>




